// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3qeSZ","legacyBtn":"MutateMid_legacyBtn__1frWh"};